module.exports = __webpack_public_path__ + "static/media/fertile ground.56a52e61.png";